import FoodIntroForm from "../../components/forms/foodIntroForm";
import FoodIntroTable from "../../components/tables/foodIntroTable";
import LoadingState from "../../components/ui/LoadingState";
import EmptyState from "../../components/ui/EmptyState";
import { useFirestore } from "../../hooks/useFirestore";
import { useChild } from "../../contexts/ChildContext";
import { exportToCSV, foodIntroCSVColumns } from "../../utils/exportUtils";
import { exportSectionPDF } from "../../utils/pdfUtils";

const FoodIntroductions = (() => {
    const { selectedChild } = useChild();
    const { items: foodIntroductions, addItem, updateItem, deleteItem, loading, error } = useFirestore("foodIntroductions", selectedChild?.id);

    const handleAddIntro = async (intro) => {
        try {
            await addItem({ ...intro, childId: selectedChild?.id });
        } catch (err) {
            console.error("Error adding food introduction:", err);
        }
    };

    const handleExport = () => {
        exportToCSV(foodIntroductions, `food-introductions-${selectedChild?.name || "export"}.csv`, foodIntroCSVColumns);
    };

    const handleExportPDF = () => {
        exportSectionPDF(foodIntroductions, `food-introductions-${selectedChild?.name || "export"}.pdf`, foodIntroCSVColumns, "Food Introductions", selectedChild?.name || "");
    };

    return (
        <div className="card h-100" id="food-introductions">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title mb-0">🍽️ Food Introductions</h5>
                    <div className="d-flex gap-1">
                        <button className="btn btn-sm btn-outline-secondary" onClick={handleExport}>⬇ CSV</button>
                        <button className="btn btn-sm btn-outline-primary" onClick={handleExportPDF}>⬇ PDF</button>
                    </div>
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <FoodIntroForm onAdd={handleAddIntro} />
                {loading ? (
                    <LoadingState message="Loading food introductions..." />
                ) : foodIntroductions.length > 0 ? (
                    <FoodIntroTable data={foodIntroductions} onUpdate={updateItem} onDelete={deleteItem} />
                ) : (
                    <EmptyState
            icon="🍽️"
            heading="No foods introduced yet"
            message="Track new foods and keep an eye out for reactions as your baby explores eating."
          />
                )}
            </div>
        </div>
    )
});

export default FoodIntroductions;
